import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        width: "100%",
        minWidth: 0
    }
});

export const useStyles = ({
    spaces
}: {
    spaces: NCoreUIKit.ActivePalette["spaces"];
}) => {
    const styles = {
        container: {
            gap: spaces.spacingXxs
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
